module.exports = __webpack_public_path__ + "static/media/brazil-flag.d30e1acf.png";